import i18n from '@/i18n';

export default [
  {
    text: i18n.t('enums.PrevisaoEntregaAcao.previsaoEntregaOriginal'),
    value: "PrevisaoEntregaOriginal",
  },
  {
    text: i18n.t('enums.PrevisaoEntregaAcao.alteracaoEntrega'),
    value: "AlteracaoEntrega",
  },
  {
    text: i18n.t('enums.PrevisaoEntregaAcao.previsaoEntregaAprovada'),
    value: "PrevisaoEntregaAprovada",
  },
];